import * as THREE from 'three'
import gsap from 'gsap'
import OffscreenArrow from './OffscreenArrow.js'

export default class DepositIndicator
{
    constructor(_options)
    {
        this.deposit = _options.deposit
        this.camera = _options.camera
        this.dismissed = false
        this.opacity = 1
        this.container = new THREE.Group()
        this.container.position.set(this.deposit.x, this.deposit.y, 3.2)
        this.item = _options.factory.createItem(this.deposit.resource, 2)
        this.container.add(this.item)
        this.ring = new THREE.Mesh(
            new THREE.TorusGeometry(0.55, 0.035, 6, 20),
            new THREE.MeshBasicMaterial({ color: '#6dffab', transparent: true, opacity: 0.7, depthTest: false })
        )
        this.container.add(this.ring)
        this.offscreenArrow = new OffscreenArrow({ camera: this.camera, position: new THREE.Vector3(this.deposit.x, this.deposit.y, 1.5) })
    }

    update(_elapsed)
    {
        if(this.dismissed)
            return
        this.item.position.z = Math.sin(_elapsed * 0.004) * 0.2
        this.item.rotation.z = Math.sin(_elapsed * 0.002) * 0.15
        this.ring.rotation.z = _elapsed * 0.001
        this.offscreenArrow.update()
    }

    dismiss()
    {
        if(this.dismissed)
            return
        this.dismissed = true
        this.offscreenArrow.remove()
        gsap.to(this.container.scale, { x: 0, y: 0, z: 0, duration: 0.5, onComplete: () => this.container.visible = false })
    }
}
